import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";

import { NEW_INTERMEDIARY_APP_ID } from "../../../config";
import { useFeature } from "../../../hooks/use-feature";
import PortaleChildApp from "../../portale-child-app";

const IntermediaryChildApp = ({ workspaceId, item }) => {
    const newIntermediary = useFeature("NEW_INTERMEDIARY");
    return newIntermediary ? (
        <PortaleChildApp
            appId="WORKSPACE"
            serviceId="rnd:core:customer-management:app"
            deepLink="/tenant/settings/intermediaries"
            oneFrontAppId={NEW_INTERMEDIARY_APP_ID}
            tenantId={workspaceId}
        />
    ) : (
        <Redirect to={`/${item.base.id}/dashboard`} />
    );
};

const mapStateToProps = (state, props) => ({
    workspaceId: state.services.workspaceId.data ? state.services.workspaceId.data.id : null,
    item: state.companies.data[props.match.params.item] ? state.companies.data[props.match.params.item].item : {}
});

export default connect(mapStateToProps)(IntermediaryChildApp);
